import React, { PureComponent } from 'react'
import MdMyLocation from 'react-icons/lib/md/my-location'
import { bool, func, string } from 'prop-types'
import MdInfoOutline from 'react-icons/lib/md/info-outline'
import { connect } from 'react-redux'
import {
  turnOnMyLocation,
  turnOnWatchLocation,
} from '../../../store/Actions/SpiActions'
import { is_ie } from '../../../store/Actions/UiActions'

const cssClass = myLocation =>
  myLocation ? 'my-location location_blink' : 'my-location'

class CurrentPosition extends PureComponent {
  handleTurnOnMyLocation = () => {
    const {
      turnOnMyLocation,
      myLocation,
      registerEvent,
      ie,
      is_ie,
    } = this.props
    if (!ie) {
      turnOnMyLocation(!myLocation)
      registerEvent({
        category: 'Address Search Bar',
        action: myLocation ? 'Turned on Locate me' : 'Turned off Locate me',
        label: 'Geolocation, my-location',
      })
    } else {
      is_ie()
    }
  }

  render() {
    const { myLocation, theme, ie } = this.props
    return (
      <button
        className={cssClass(myLocation)}
        onClick={() => this.handleTurnOnMyLocation()}
        tabIndex="3"
      >
        {ie ? (
          <MdInfoOutline color="grey" />
        ) : (
          <MdMyLocation color={myLocation ? '#3F51B5' : theme} />
        )}
      </button>
    )
  }
}

class ContinuousPosition extends PureComponent {
  handleTurnOnWatchLocation = () => {
    const {
      watchLocation,
      registerEvent,
      turnOnWatchLocation,
      ie,
      is_ie,
    } = this.props
    if (!ie) {
      turnOnWatchLocation(!watchLocation)
      registerEvent({
        category: 'Address Search Bar',
        action: 'Turned off Watch Position',
        label: 'Geolocation, watch-position',
      })
    } else {
      is_ie()
    }
  }
  render() {
    const { watchLocation, ie } = this.props
    return (
      <button
        className={cssClass(watchLocation)}
        onClick={() => this.handleTurnOnWatchLocation()}
      >
        {ie ? <MdInfoOutline color="grey" /> : <MdMyLocation color="#3498db" />}
      </button>
    )
  }
}

const MyLocation = ({
  watchLocation,
  turnOnWatchLocation,
  myLocation,
  turnOnMyLocation,
  theme,
  registerEvent,
  ie,
  is_ie,
}) =>
  watchLocation ? (
    <ContinuousPosition
      watchLocation={watchLocation}
      turnOnWatchLocation={turnOnWatchLocation}
      theme={theme}
      registerEvent={registerEvent}
      ie={ie}
      is_ie={is_ie}
    />
  ) : (
    <CurrentPosition
      myLocation={myLocation}
      turnOnMyLocation={turnOnMyLocation}
      theme={theme}
      registerEvent={registerEvent}
      ie={ie}
      is_ie={is_ie}
    />
  )

MyLocation.propTypes = {
  myLocation: bool.isRequired,
  watchLocation: bool.isRequired,
  turnOnWatchLocation: func.isRequired,
  turnOnMyLocation: func.isRequired,
  theme: string.isRequired,
  registerEvent: func.isRequired,
  ie: bool.isRequired,
}

const mapStateToProps = ({ spi, ui }) => ({
  myLocation: spi.myLocation,
  watchLocation: spi.watchLocation,
  theme: spi.theme,
  ie: ui.ie,
})

const mapDispatchToProps = dispatch => ({
  turnOnMyLocation: value => dispatch(turnOnMyLocation(value)),
  turnOnWatchLocation: value => dispatch(turnOnWatchLocation(value)),
  is_ie: () => dispatch(is_ie()),
})

export default connect(mapStateToProps, mapDispatchToProps)(MyLocation)



// WEBPACK FOOTER //
// ./src/components/Elements/AddressBar/MyLocation.jsx